<template>
  <div id="app">
    <el-container class="app-container">

      <el-header class="app-header">
        <Header />
      </el-header>

      <el-main class="app-main">
        <router-view/>
      </el-main>

      <el-footer class="app-footer">
        <Footer />
      </el-footer>

    </el-container>
  </div>
</template>

<script>
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';

export default {
  name: 'App',
  components: {
    Header,
    Footer
  }
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
}

#app {
  font-family: 'Inter', 'Noto Sans JP', sans-serif;
}

.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.app-header, .app-footer {
  flex-shrink: 0;
}
.app-header{
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

  position: relative;
  z-index: 10;
}
.app-footer {
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.15);

  position: relative;
  z-index: 9;
}
.el-header{
  padding: 0 !important;
}
.el-footer{
  height: auto !important;
  padding: 0 !important;
}
.app-main {
  flex-grow: 1;
  padding: 0;
  overflow-y: auto;
}
</style>
